import { c as _c } from "react/compiler-runtime";
import { gql, useQuery } from '@material-bank/graphql-client';
type SaveStatus = {
  isSaved: boolean;
  folderIds: string[];
};
type ProductSaveStatusData = {
  productSaveStatus: SaveStatus;
};
type ProductSaveStatusVars = {
  variantSku: string;
};
export const PRODUCT_SAVE_STATUS_QUERY = gql`
  query ProductSaveStatus($variantSku: String!) {
    productSaveStatus(variantSku: $variantSku) {
      isSaved
      folderIds
    }
  }
`;
export function useProductSaveStatusQuery(variantSku, t0) {
  const $ = _c(10);
  const skip = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== variantSku) {
    t1 = {
      variantSku
    };
    $[0] = variantSku;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = skip || !variantSku;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      variables: t1,
      skip: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(PRODUCT_SAVE_STATUS_QUERY, t3);
  const t4 = data?.productSaveStatus ?? null;
  let t5;
  if ($[5] !== error || $[6] !== loading || $[7] !== refetch || $[8] !== t4) {
    t5 = {
      saveStatus: t4,
      loading,
      error,
      refetch
    };
    $[5] = error;
    $[6] = loading;
    $[7] = refetch;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}